import { fabric } from 'fabric';
import { globalHttpRequest } from '../util/globalHttpService';
import { generateSvgForOTP } from './generateSvgForOTP';
import tingle from 'tingle.js';
let optionSelected = {};
const CUSTOMIZATION = ['color', 'personalizationPositionKey', 'fontFamily', 'text'];
const canvasSection = '.canvasSection';
const loadingTime = 300;
// eslint-disable-next-line no-useless-escape
const allowedCharRegex = /^[a-zA-Z]*$/;
let canvasElem;
let canvasImg;
let canvasText;
let canvasRect;
let canvasGroup;
let canvasIcon;
let badWords = [];
let isCartEdit = false;
let persOldOptions;
let lastFocusedElement;
const sizeRatioFont = 0.04;
let customizeSymbol = ' ';
let openPersonalizationModalStatus = false;

function trapFocus(e) {
    if (e.key !== 'Tab' && e.keyCode !== 9) return;

    const $modal = $('.fnPersonalizationPageContainer.opened');
    if (!$modal.length) return;

    // If is visible a tingle modal (annidata), do not interfere with its focus
    if ($('.tingle-modal--visible').length) {
        if ($(document.activeElement).closest('.tingle-modal').length) {
            return;
        }
    }

    const focusableElements = $modal.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible');
    if (!focusableElements.length) return;

    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    if (e.shiftKey) { /* shift + tab */
        if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus();
            e.preventDefault();
        }
    } else { /* tab */
        if (document.activeElement === lastFocusableElement) {
            firstFocusableElement.focus();
            e.preventDefault();
        }
    }
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
const handlePostCartAdd = response => {
    $('.minicart').trigger('count:update', response);
    if (response.newBonusDiscountLineItem &&
        Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if (response.error) {
            return;
        }
        if ($('.add-to-cart-messages').length === 0) {
            $('.minicart').append(
                '<div class="add-to-cart-messages"></div>'
            );
        }
    }
};

const newModalFromString = (html, footer, cssClass = [], onOpen, onClose) => {
    // set optionts
    const modalOptions = {
        closeMethods: ['overlay', 'button', 'escape'],
        cssClass,
        onClose: () => {
            modal.destroy();
            if (typeof onClose === 'function') {
                onClose();
            }
        },
        onOpen: onOpen
    };
    if (footer) { modalOptions.footer = true; };

    // create modal
    const modal = new tingle.modal(modalOptions);

    // add content
    if (html) {
        modal.setContent(html);
    }

    const modalBoxSelect = $(modal.modalBox).find('select');
    // apply chosen.js to <select> elements
    if (modalBoxSelect.length) {
        if (Foundation.MediaQuery.atLeast('large')) {
            /* modalBoxSelect.chosen();  TODO */
        } else {
            modalBoxSelect.closest('.label-inside').addClass('focused');
        }
    }
    return modal;
};

const parseHtml = html => {
    var $html = $('<div>').append($.parseHTML(html));

    var body = '';
    let $results = $html.find('.choice-of-bonus-product');
    for (let i = 0; i < $results.length; i++) {
        body += $results[i].outerHTML;
    }
    var footer = $html.find('.modal-footer').children().html();

    return {
        body: body,
        footer: footer
    };
};

const chooseBonusProducts = data => {
    // $('.modal-body').spinner().start();
    const bonusUrl = data.bonusChoiceRuleBased ? data.showProductsUrlRuleBased : data.showProductsUrlListBased;

    var htmlString = `
        <div class="modal-content bonus-product choose-bonus-product-dialog"
            id="chooseBonusProductModal"
            data-total-qty="${data.maxBonusItems}"
            data-UUID="${data.uuid}"
            data-pliUUID="${data.pliUUID}"
            data-addToCartUrl="${data.addToCartUrl}"
            data-pageStart="0"
            data-pageSize="${data.pageSize}"
            data-moreURL="${data.showProductsUrlRuleBased}"
            data-bonusChoiceRuleBased="${data.bonusChoiceRuleBased}">
            <div class="modal-header">
                <h4 class="">${data.labels.selectprods}</h4>
                <button type="button" class="close close-custom" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"></span></button>
            </div>
            <div class="modal-body"></div>
            <div class="modal-footer"></div>
            <div class="col-sm-12 text-center modal-footer-button">
                <button class="button btn-outline-primary col-12 col-sm-4 js-confirm-bonus-products">
                ${data.labels.confirm}
                </button>
            </div>
        </div>`;

    const modalContent = document.createElement('div');
    modalContent.innerHTML = htmlString;

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: rsp => {
            var parsedHtml = parseHtml(rsp.renderedTemplate);
            modalContent.querySelector('.modal-body').innerHTML = parsedHtml.body !== '' ? parsedHtml.body : rsp.renderedTemplate;
            modalContent.querySelector('.modal-footer').innerHTML = parsedHtml.footer ? parsedHtml.footer : '';
            if (parsedHtml.body === '') {
                modalContent.querySelector('.modal-footer-button').innerHTML = '';
            }
            const onPopupClose = () => {
                if (data.isTriggeredByCoupon) {
                    window.location.reload();
                }
            };
            const modal = newModalFromString(modalContent, false, ['bonus-product-modal'], null, onPopupClose);

            $('.bonus-product-modal').addClass('bonus-modal--tezenis');
            $(modal.modalBox).addClass('rightModalAttribute');

            if ($('.page').data('action') === 'Cart-Show') {
                $('.bonus-product-item .quickviewCarousel__slider').slick({
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false
                });

                modal.open();
            } else {
                setTimeout(function () {
                    modal.open();
                    if ($('.product-quickview-bonus-product').length === 1 && $('.product-quickview-bonus-product').hasClass('product-master')) {
                        $('.product-quickview-bonus-product').find('.slider-values-container .color-variation .selectable').eq(0).trigger('click');
                    }
                    $('.bonus-product-item .quickviewCarousel__slider').slick({
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: false
                    });
                }, 2000);
            }

            var bonusProductItems = $('.bonus-product-item');
            for (var i = 0; i < bonusProductItems.length; i++) {
                var bpi = bonusProductItems.eq(i);
                var openers = $(bpi).find('.js-panel-opener-free-gift');
                var colorLabel = $(bpi).find('.product-selection-label-color');
                if (colorLabel.length > 0 && openers.length > 1 && !$(colorLabel).hasClass('hidden')) {
                    $(openers.eq(1)).removeClass('js-panel-opener');
                }
            }
            $(modal.modalBox)
                .find('.close')
                .on('click', function (e) {
                    modal.close();
                });

            $('[data-dismiss="modal"]').on('click', function (e) {
                e.preventDefault();
                modal.close();
            });
            $('body').trigger('bonusProduct:quickviewOpen', { products: rsp.products, container: $(modal.modalBox).find('#chooseBonusProductModal') });
            $('.js-confirm-bonus-products').on('click', function (e) {
                e.preventDefault();
                let selectedBonusProductId = 'bonus_product_' + $('input[name="bonus-product-choice"]:checked').val();
                let $selectedBonusProduct = $('[id="' + selectedBonusProductId + '"]');

                if ($selectedBonusProduct.find('.slider-values-container .color-variation .selected').length > 0 &&
                    $selectedBonusProduct.find('.js-accordion-size-wrapper .sizes-container input:checked').length > 0) {
                    $selectedBonusProduct.find('.add-bonus-products').trigger('click');
                } else {
                    if ($selectedBonusProduct.find('.slider-values-container .color-variation .selected').length === 0) {
                        $selectedBonusProduct.find('.slider-values-container .color-variation .selectable').eq(0).trigger('click');
                    }
                    $('.bonus-product-item .product-quickview').hide();
                    $('.js-confirm-bonus-products').closest('.modal-footer-button').hide();
                    $selectedBonusProduct.removeClass('hidden');
                }
            });
        },
        error: () => {
            $.spinner().stop();
        }
    });
};

function checkSizeAndScreen (pid) {
    if (!pid) {
        return false;
    } else {
        return true;
    }
};

function isSizeSelected () {
    if ($('.page-checkout').length > 0 || $('.cart-page').length > 0 || ($('.product-detail').data('pid') && $('.product-detail').data('pid').indexOf('TU') > - 1) || ($('.js-accordion-title .sizeSelected').length > 0 && $('.js-accordion-title .sizeSelected').html() !== '')) {
        return true;
    }
    return $('[data-attr="size"] input:checked').length > 0;
};

function getCustomizeModal (elem) {
    let url, pid;
    let uuid = '';
    lastFocusedElement = elem;
    if (!isCartEdit) {
        pid = $('.js-createPersonalization').data('pid') || null;
        url = $('.js-createPersonalization').data('url') || null;
        let quantity = 1;
        url += '?pid=' + pid + '&quantity=' + quantity;
    } else {
        url = $(elem).parent().find('.js-personalization-edit').data('url') || null;
        uuid = $(elem).parent().find('.js-personalization-edit').data('uuid') || null;
    }
    if (url && openPersonalizationModalStatus === false) {
        openPersonalizationModalStatus = true;
        globalHttpRequest(url).then(function (data) {
            openPersonalizationModal(data, uuid);
        });
    }
};

function clickBackgroundEventSizeModal (e) {
    if (e.originalEvent.target.className === 'selectSizeForCustomize js-selectSizeForCustomize') {
        closeSizeSelectBeforeCustomization();
    }
};

function closeSizeSelectBeforeCustomization () {
    $('.js-selectSizeForCustomize').slideUp('fast', function () {
        $('.bubble-element.on-mobile').removeClass('d-none');
        $('.size-mobile-modal-btn-warpper').show();
        $('.notifyMeModalMobile').addClass('hidden');
    });
    $('.js-selectSizeForCustomize').off('click', clickBackgroundEventSizeModal);
    $('.js-startPersonalize').off('click', selectSizeBeforeCustomizationMobile);
};

function selectSizeBeforeCustomizationMobile () {
    let sizeButton = $(this);
    let url = sizeButton.data('url');
    if (sizeButton.hasClass('text-dark-grey')) {
        if (!sizeButton.hasClass('notifyMe')) {
            closeSizeSelectBeforeCustomization();
        }
    } else {
        globalHttpRequest(url).then(function (response) {
            $('.js-createPersonalization').data('pid', response.product.id);
            closeSizeSelectBeforeCustomization();
            getCustomizeModal();
        }, function () {
            closeSizeSelectBeforeCustomization();
        });
    }
};

function clickBackgroundEventPersonalizationModal (e) {
    if (e.originalEvent && e.originalEvent.target.className === 'fnPersonalizationPageContainer') {
        preClosePersonalizationModal();
    }
};

function openPersonalizationModal (template, uuid) {
    $('body').addClass('noscroll');
    $('body').append(template);
    waitToLoadAllImages().then(function () {
        $('.fnPersonalizationPageContainer').addClass('opened');
        if (isCartEdit) {
            $('.js-confirmPersonalization .editPersonalization').removeClass('d-none');
            $('.js-confirmPersonalization').data('uuid', uuid);
        } else {
            $('.js-confirmPersonalization .newPersonalization').removeClass('d-none');
        }
        initEvent();
        $('.fnPersModal-header-close').focus();
    });
};

function reloadPersonalizationModal (template) {
    $('.fnPersonalizationPageContainer').replaceWith(template);
    waitToLoadAllImages().then(function () {
        if (isCartEdit) {
            $('.js-confirmPersonalization .editPersonalization').removeClass('d-none');
        } else {
            $('.js-confirmPersonalization .newPersonalization').removeClass('d-none');
        }
        $('.fnPersonalizationPageContainer').css({ width: '100%' });
        initEvent();
    });
};

function initEvent () {
    $('.fnPersonalizationPageContainer').on('click', clickBackgroundEventPersonalizationModal);
    $('.fnPersonalizationPageContainer .js-closeModal').on('click', preClosePersonalizationModal);
    $('.fnPersonalizationPageContainer .js-customizationPositions').on('change', changeCustomizationPositions);
    $('.fnPersonalizationPageContainer .js-inputText').on('change input paste', changeInputText);
    $('.fnPersonalizationPageContainer .js-changeFontFamily').on('change', changeFontFamily);
    $('.fnPersonalizationPageContainer .js-changeColor').on('change', changeColorSelect);
    $('.fnPersonalizationPageContainer .js-embroiderySize').on('change', changeEmbroiderySize);
    $('.fnPersonalizationPageContainer .js-confirmPersonalization').on('click', confirmPersonalization);
    $('.fnPersonalizationPageContainer .js-legal-personalization').on('click', mobileLegalModal);
    $('.js-personalization-symbols .symbol').on('click', addSymbol);
    $(window).on('resize', resizeScreen);
    $(document).on('keydown.personalization', trapFocus);
    (isCartEdit) ? editPersonalization() : initVariable();
    getBadWords();
};


function getBadWords () {
    if (badWords.length === 0) {
        let badWordsUrl = $('#badWords').data('url');
        globalHttpRequest(badWordsUrl, 'POST').then(function (data) {
            if (data && data.context && data.context.wordsArr) {
                badWords = data.context.wordsArr;
            }
        });
    }
};

function initVariable () {
    optionSelected = {};
    optionSelected.text = '';
    optionSelected.personalizationType = $('.js-changeTypology.active ').data('typology');
    $('.fnPersonalizationPageContainer input:radio:checked').prop('checked', false);
    $('.fnPersonalizationPageContainer .js-inputText').val('');
    $('.fnPersModal-image').removeClass('visually-hidden');
    $('.canvasSection').addClass('d-none');
    canvasElem, canvasImg, canvasText = '';
    customizeSymbol = ' ';
};

function waitToLoadAllImages () {
    let defer = jQuery.Deferred();
    let imagesNumber = $('.fnPersModal-image-custom').length;
    let loadComplete = 0;
    $.spinner().start();
    $('.fnPersModal-image-custom').one('load', function () {
        loadComplete++;
        if (loadComplete === imagesNumber) {
            $.spinner().stop();
            defer.resolve(true);
        }
    }).on('error', function () {
        loadComplete++;
        if (loadComplete === imagesNumber) {
            $.spinner().stop();
            defer.resolve(true);
        }
    }).each(function () {
        if (this.complete) {
            $(this).trigger('load');
        } else if (this.error) {
            $(this).error();
        }
    });
    return defer.promise();
};

function editPersonalization () {
    canvasElem, canvasImg, canvasText = '';
    optionSelected = {};
    persOldOptions = $('#editParamsPersonalization').data('editParams');

    $('input:radio:checked').prop('checked', false);
    $('.selectHeaderOption').html('');

    $('.js-inputText').val(persOldOptions.personalizationText).trigger('change');
    optionSelected.text = persOldOptions.personalizationText;

    $('input:radio[name=selectFontFamily][value="' + persOldOptions.personalizationTextFont + '"]').click();
    $('input:radio[name=selectColor][value="' + persOldOptions.personalizationTextColor + '"]').click();
    $('input:radio[name=customizationPositionsInput][data-position-types="' + persOldOptions.personalizationPositionKey + '"]').click();
};

function setTextOffset ($selectedIcon, textLength) {
    if (canvasText && canvasIcon) {
        let textCoordinateX = 0;
        let textCoordinateY = canvasText.get('top');
        let iconCoordinateX = canvasIcon.get('left');
        let text = optionSelected.text;
        let canvasIconLeft;
        let font = 20;
        let textUpperCase = false;
        if (text === text.toUpperCase()) {
            textUpperCase = true;
        }
        if ($selectedIcon.length > 0) {
            if (textLength > 0) {
                canvasIconLeft = optionSelected.cordX * optionSelected.scale + 70 + 15 + (textLength * 6);
                canvasText.set('left', -25 + (textLength * -0.3));
                canvasIcon.set('left', canvasIconLeft);

                textCoordinateX = optionSelected.cordX + (optionSelected.rectWidth / 2) + (textLength * -30);
                iconCoordinateX = optionSelected.cordX + (optionSelected.rectWidth / 2) + (textLength * 40);
                let extraSpacingForWideChars = 0;
                if (optionSelected.fontFamilyCode === 'parisienneRegular' && textUpperCase) {
                    extraSpacingForWideChars = 15;
                    if (textLength > 4 && textLength < 8) {
                        font = font - 5;
                    } else if (textLength > 7) {
                        font = font - 9;
                        extraSpacingForWideChars = 5;
                    }
                } else {
                    if (textLength > 7) {
                        if (textUpperCase) {
                            font = font - 4;
                        }
                    }
                }
                let fontLetterDecrease = 0;

                for (var i = 0; i < text.length; i++) {
                    if (/[WM]/.test(text.charAt(i))) {
                        extraSpacingForWideChars += 3;
                        fontLetterDecrease = 1;
                    }
                    if (/[wm]/.test(text.charAt(i))) {
                        extraSpacingForWideChars += 2;
                        fontLetterDecrease = 1;
                    }
                }
                font = font - fontLetterDecrease;
                canvasIcon.set('left', canvasIconLeft + extraSpacingForWideChars);
                canvasText.set('fontSize', font);
            } else {
                canvasText.set('left', 0);
                canvasIcon.set('left', optionSelected.cordX * optionSelected.scale + 86);

                textCoordinateX = optionSelected.cordX;
                iconCoordinateX = optionSelected.cordX + (optionSelected.rectWidth / 2);
            }
        } else {
            canvasText.set('left', 0);
            canvasIcon.set('left', optionSelected.cordX * optionSelected.scale + 80);

            textCoordinateX = optionSelected.cordX + (optionSelected.rectWidth / 2) + (textLength * -25);
            iconCoordinateX = optionSelected.cordX + (optionSelected.rectWidth / 2);
            if (optionSelected.fontFamilyCode === 'parisienneRegular' && textUpperCase) {
                font = font - 5;
                canvasText.set('fontSize', font);
            } else if (textUpperCase && textLength > 7) {
                font = font - 6;
                canvasText.set('fontSize', font);
            }
        }
        canvasText.set('fontSize', font);

        optionSelected.textCoordinateX = textCoordinateX;
        optionSelected.textCoordinateY = textCoordinateY + optionSelected.cordY + 90;
        optionSelected.iconCoordinateX = iconCoordinateX;
        optionSelected.iconCoordinateY = textCoordinateY + optionSelected.cordY + 55;
        optionSelected.fontScaled = font / 20;
    }
}

function initCanvas () {
    // Add initial default variabels, they will be overwritten if the user will change them
    if (optionSelected && !optionSelected.fontFamily) {
        optionSelected.fontFamily = 'Inter SemiBold';
    }
    if (optionSelected && !optionSelected.fontFamilyCode) {
        optionSelected.fontFamilyCode = 'Inter SemiBold';
    }
    if (optionSelected && !optionSelected.color) {
        optionSelected.color = 'black';
    }
    if (optionSelected && !optionSelected.colorName) {
        optionSelected.colorName = 'black';
    }
    if (optionSelected && !optionSelected.colorCode) {
        optionSelected.colorCode = '#000000';
    }

    let wit = $('.fnPersModal-image').width();
    canvasElem = new fabric.StaticCanvas('personalizationCanvas');
    let imgElement = $('.fnPersModal-image-custom.' + optionSelected.customizationPositionsCode)[0];
    const textLength = $('.fnPersonalizationPageContainer .js-inputText').val().length;
    optionSelected.originalImage = {
        width: imgElement.width,
        height: imgElement.height,
        image: imgElement
    };
    let scale = wit / imgElement.width;
    optionSelected.scale = scale;
    canvasElem.setWidth(wit);
    canvasElem.setHeight(scale * imgElement.height);
    canvasImg = new fabric.Image(imgElement, {
        left: 0,
        top: 0,
        scaleX: scale,
        scaleY: scale
    });

    let textOptions = {
        fill: optionSelected.colorCode,
        fontFamily: optionSelected.fontFamilyCode,
        fontSize: 20,
        textAlign: 'center',
        originX: 'center',
        originY: 'center',
        lineHeight: 40,
        height: 40,
        // width: 154, // Apply same width as rect to avoid wrapping to multiple lines (MEC-28548)
        top: 0,
        left: textLength && textLength > 0 ? -7 + (textLength * -2) : 0
    };

    optionSelected.fontFamilySize = 20;

    let rectOptions = {
        strokeDashArray: [5, 5],
        width: 166,
        height: 66,
        fill: 'rgba(100, 100, 100, 0.1)',
        stroke: 'black',
        strokeWidth: 1,
        rx: 4,
        ry: 4,
        originX: 'center',
        originY: 'center'
    };

    let iconOptions = {
        width: 400,
        height: 400,
        originX: 'center',
        originY: 'center',
        scaleX: 0.1,
        scaleY: 0.1,
        top: optionSelected.cordY * scale + 33,
        left: optionSelected.cordX * scale + 88,
        angle: optionSelected.rotate
    };

    let text = optionSelected.text || '';
    canvasText = new fabric.Text(text, textOptions);

    const $selectedIcon = $('.js-personalization-symbols .symbol.active img');
    const defaultIcon = $('.js-personalization-symbols .symbol img').first()[0];
    const iconImage = $selectedIcon.length > 0 ? $selectedIcon[0] : defaultIcon;
    const iconImageSrc = getSelectedColorURL();
    if (iconImageSrc) {
        const iconImageClone = iconImage.cloneNode();
        iconImageClone.setAttribute('src', iconImageSrc);
        updateOptionIconImage(iconImageClone);
    }

    if (!canvasIcon) {
        canvasIcon = new fabric.Image('', iconOptions);

        if (iconImageSrc) {
            canvasIcon.setSrc(iconImageSrc);
        }
    }

    canvasRect = new fabric.Rect(rectOptions);
    canvasGroup = new fabric.Group([ canvasRect, canvasText ], {
        top: optionSelected.cordY * scale,
        left: optionSelected.cordX * scale,
        angle: optionSelected.rotate
    });

    setTimeout(() => {
        canvasElem.add(canvasImg);
        canvasElem.add(canvasGroup);
        canvasElem.add(canvasIcon);
        canvasElem.renderAll();
    }, loadingTime);

    setTextOffset($selectedIcon, textLength);
    $('.fnPersModal-image').addClass('visually-hidden');
    $(canvasSection).removeClass('d-none');
};

function changeCanvasImage () {
    if ($(canvasSection).hasClass('d-none')) {
        initCanvas();
    } else {
        let imgElement = $('.fnPersModal-image-custom.' + optionSelected.customizationPositionsCode)[0];
        canvasImg._element = imgElement;
        optionSelected.originalImage.image = imgElement;
        canvasGroup.set('top', optionSelected.cordY * optionSelected.scale);
        canvasGroup.set('left', optionSelected.cordX * optionSelected.scale);
        canvasGroup.set('angle', optionSelected.rotate);
        canvasIcon.set('top', optionSelected.cordY * optionSelected.scale + 33);
        canvasIcon.set('angle', optionSelected.rotate);

        let textLength = $('.fnPersonalizationPageContainer .js-inputText').val().length;
        let $selectedIcon = $('.js-personalization-symbols .symbol.active');
        setTextOffset($selectedIcon, textLength);

        canvasElem.renderAll();
    }
};

function resizeScreen () {
    if (!$(canvasSection).hasClass('d-none')) {
        initCanvas();
    }
};

function updateInitialVariables (updateIcon = false) {
    let $selectedFont = $('.fnPersonalizationPageContainer input:radio[name=selectFontFamily]:checked');
    let $selectedColor = $('.fnPersonalizationPageContainer input:radio[name=selectColor]:checked');
    let $selectedPosition = $('.fnPersonalizationPageContainer input:radio[name=customizationPositionsInput]:checked');

    if (!$selectedPosition.length) {
        $selectedPosition = $('.fnPersonalizationPageContainer input:radio[name=customizationPositionsInput]').first();
        $selectedPosition.trigger('click');
    }

    if (!$selectedFont.length && !updateIcon) {
        $selectedFont = $('.fnPersonalizationPageContainer input:radio[name=selectFontFamily]').first();
        $selectedFont.trigger('click');
    }

    if (!$selectedColor.length) {
        $selectedColor = $('.fnPersonalizationPageContainer input:radio[name=selectColor]').first();
        $selectedColor.trigger('click');
    }
}

function updateCanvasText (property, value) {
    if (canvasText) {
        canvasText.set(property, value);

        const $selectedIcon = $('.js-personalization-symbols .symbol.active');
        // let symbolSrcText = $selectedIcon.length > 0 ? $selectedIcon.data('code') : '\u00A0';
        // updateIconStyle(symbolSrcText);

        let textLength = $('.fnPersonalizationPageContainer .js-inputText').val().length;
        setTextOffset($selectedIcon, textLength);

        setTimeout(() => {
            canvasElem.renderAll();
        }, loadingTime);
    }
};

function getSelectedColorURL (value = '') {
    let colorName = value || $('.js-changeColor:checked').data('title');
    let iconImage = $('.js-personalization-symbols .symbol.active img')[0];

    if (iconImage) {
        let iconImageSrc = iconImage ? iconImage.src : '';
        let URLlength = iconImageSrc.length - 10;
        let baseSrc = iconImageSrc.substring(0, URLlength);
        let newSrc = baseSrc + colorName + '.png';
        return newSrc;
    }
};

function updateCanvasIconSrc (value) {
    let newSrc = getSelectedColorURL(value);
    if (canvasIcon) canvasIcon.setSrc(newSrc);

    const $selectedIcon = $('.js-personalization-symbols .symbol.active img');
    const iconImage = $selectedIcon[0];
    if (newSrc) {
        const iconImageClone = iconImage.cloneNode();
        iconImageClone.setAttribute('src', newSrc);
        updateOptionIconImage(iconImageClone);
    }

    if (canvasElem) {
        setTimeout(() => {
            canvasElem.renderAll();
        }, loadingTime);
    }
};

function cleanIconImage () {
    optionSelected.iconImage = undefined;
}

function updateOptionIconImage (imageClone) {
    let wit = $('.fnPersModal-image').width();
    let imgElement = optionSelected.customizationPositionsCode ?
        $('.fnPersModal-image-custom.' + $('.content-positions input').first().data('image'))[0] :
        $('.fnPersModal-image-custom.' + optionSelected.customizationPositionsCode)[0];
    let imgElementWith = imgElement && imgElement.width ? imgElement.width : '2000';
    let scale = wit / imgElementWith;
    let iconOptions = {
        width: 400,
        height: 400,
        originX: 'center',
        originY: 'center',
        scaleX: 0.5,
        scaleY: 0.5,
        top: optionSelected.cordY * scale + 33,
        left: optionSelected.cordX * scale + 88,
        angle: optionSelected.rotate
    };

    optionSelected.iconImage = {
        width: iconOptions.width,
        height: iconOptions.height,
        top: iconOptions.top,
        left: iconOptions.left,
        angle: iconOptions.angle,
        scaleX: iconOptions.scaleX,
        scaleY: iconOptions.scaleY,
        originX: 'center',
        originY: 'center',
        image: imageClone
    };
}

// function updateCanvasIcon (property, value) {
//     if (canvasText) {
//         updateIconStyle(value);
//         canvasElem.renderAll();
//     }
// };

function closePersonalizationModal () {
    $('body').removeClass('noscroll');
    $('.fnPersonalizationPageContainer').removeClass('opened');
    openPersonalizationModalStatus = false;
    $('.fnPersonalizationPageContainer').remove();

    canvasIcon = null;
    $(document).off('keydown.personalization');
    if (lastFocusedElement) {
        $(lastFocusedElement).focus();
    }
};

function changeCustomizationPositions () {
    let input = $(this);
    let val = input.val();
    optionSelected.customizationPositionsCode = input.data('image');
    optionSelected.cordY = input.data('coordinateY');
    optionSelected.cordX = input.data('coordinateX');
    optionSelected.rotate = input.data('rotate');
    optionSelected.rectWidth = input.data('rectWidth');
    optionSelected.personalizationPositionKey = input.data('positionTypes');
    $(".fnPersModal-options-accordion-header[data-options='customizationPositions'] .selectHeaderOption").html(val);
    let persText = $('.js-inputText').val();
    let allowedChars = allowedCharRegex.test(persText);
    checkFillComplete(!allowedChars);
    changeCanvasImage();
};

function checkBadWordsText (val) {
    let words = val.split(' ');
    let check = true;
    for (let i = 0; i < words.length; i++) {
        const word = words[i];
        if (word.length > 2) {
            check = badWords.indexOf(word) < 0;
        }
        if (check === false) {
            break;
        }
    }
    return check;
};

function changeInputText () {
    let input = $(this);
    // eslint-disable-next-line no-useless-escape
    var val = input.val();
    var allowedChars = allowedCharRegex.test(val);
    let max = input.attr('maxlength');
    if (val.length > max) {
        val = val.substr(0, max);
    }
    input.val(val);
    updateInitialVariables();

    if (!checkBadWordsText(val)) {
        $('.fnPersModal-options-accordion-body-inputContainerText .badWords').slideDown('fast');
        $('.fnPersModal-options-accordion-body-inputContainerText.word').addClass('badInput');
        val = '';
    } else {
        $('.fnPersModal-options-accordion-body-inputContainerText .badWords').slideUp('fast');
        $('.fnPersModal-options-accordion-body-inputContainerText.word').removeClass('badInput');
    }
    if (!allowedChars) {
        $('.fnPersModal-options-accordion-body-inputContainerText .badChar').slideDown('fast');
        $('.fnPersModal-options-accordion-body-inputContainerText.word').addClass('badInputChar');
    } else {
        $('.fnPersModal-options-accordion-body-inputContainerText .badChar').slideUp('fast');
        $('.fnPersModal-options-accordion-body-inputContainerText.word').removeClass('badInputChar');
    }
    $('.limitNumberCounter-count').html(val.length);
    optionSelected.text = val;
    checkEmbroidery();
    checkFillComplete(!allowedChars);
    updateCanvasText('text', val);

    const $selectedIcon = $('.js-personalization-symbols .symbol.active');
    let textLength = $('.fnPersonalizationPageContainer .js-inputText').val().length;
    setTextOffset($selectedIcon, textLength);
};

function changeFontFamily () {
    let input = $(this);
    let val = input.val();
    let css = input.data('value');
    optionSelected.fontFamily = val;
    optionSelected.fontFamilyCode = css;
    checkEmbroidery();
    updateCanvasText('fontFamily', css);
};

function changeColorSelect () {
    let input = $(this);
    let val = input.val();
    let css = input.data('code');
    let nameColor = input.data('description');
    let colorTitle = input.data('title');
    optionSelected.color = val;
    optionSelected.colorName = nameColor;
    optionSelected.colorCode = css;
    checkEmbroidery();
    updateCanvasText('fill', css);
    updateCanvasIconSrc(colorTitle);
};

function checkEmbroidery () {
    let checked = true;
    let tempArray = [];
    const PROP = ['text', 'fontFamily', 'colorName'];
    for (let i = 0; i < PROP.length; i++) {
        const el = PROP[i];
        if (!optionSelected.hasOwnProperty(el) || optionSelected[el] === '') {
            checked = false;
            break;
        } else {
            tempArray.push(optionSelected[el]);
        }
    }
    if (checked) {
        $(".fnPersModal-options-accordion-header[data-options='defineEmbroidery'] .selectHeaderOption").html(tempArray.join(' - '));
    }
};

function changeEmbroiderySize () {
    let input = $(this);
    let val = input.val();
    let text = val + ' cm';
    optionSelected.embroiderySize = val;
    optionSelected.embroiderySizeText = text;
    $(".fnPersModal-options-accordion-header[data-options='embroiderySize'] .selectHeaderOption").html(text);
    if (optionSelected.originalImage) {
        updateCanvasText('fontSize', val * sizeRatioFont * optionSelected.scale * optionSelected.originalImage.height);
    }
};

function checkFillComplete (allowedChars = false) {
    let disabled = false;
    for (let i = 0; i < CUSTOMIZATION.length; i++) {
        const key = CUSTOMIZATION[i];
        if (!optionSelected.hasOwnProperty(key) || optionSelected[key] === '') {
            disabled = true;
            break;
        }
    }
    $('.js-confirmPersonalization').prop('disabled', disabled || allowedChars);
};

function addSymbol () {
    $(this).siblings().removeClass('active');
    $(this).toggleClass('active');

    updateInitialVariables(true);

    const $selectedIcon = $('.js-personalization-symbols .symbol.active img');
    const iconImage = $selectedIcon[0];
    const iconImageSrc = getSelectedColorURL();
    let textLength = $('.fnPersonalizationPageContainer .js-inputText').val().length;

    if (iconImageSrc) {
        const iconImageClone = iconImage.cloneNode();
        iconImageClone.setAttribute('src', iconImageSrc);
        updateOptionIconImage(iconImageClone);
    } else {
        cleanIconImage();
    }

    setTextOffset($selectedIcon, textLength);

    if ($(this).hasClass('active')) {
        customizeSymbol = $(this).find('img').eq(0).prop('outerHTML').replace(/"/g, "'");
    } else {
        customizeSymbol = ' ';
    }
    if (canvasIcon) {
        canvasIcon.setSrc(iconImageSrc);
    }
    if (canvasElem) {
        setTimeout(() => {
            canvasElem.renderAll();
        }, loadingTime);
    }
    var allowedChars = allowedCharRegex.test($('.fnPersonalizationPageContainer .js-inputText').val());
    $('.js-confirmPersonalization').prop('disabled', !allowedChars || !((textLength > 0) || $('.js-personalization-symbols .symbol.active').length > 0));
};

function confirmPersonalization () {
    let addToCartUrl = $('#personalizationPage').attr('data-url');
    let personalizationText = optionSelected.text + customizeSymbol;
    let personalizationTextFont = optionSelected.fontFamily;
    let personalizationTextColor = optionSelected.color;
    let personalizationPositionKey = optionSelected.personalizationPositionKey;
    let personalizationType = (optionSelected.text && optionSelected.text.length > 0) ? (customizeSymbol !== ' ' ? '3' : '1') : (customizeSymbol !== ' ' ? '2' : '');

    let svgObject = generateSvgForOTP(optionSelected);
    let personalizationTextSVG = svgObject.personalizationTextSVG;
    let personalizationFullSVG = svgObject.personalizationFullSVG;
    let personalizationSmallSVG = svgObject.personalizationSmallSVG;

    let quantity = $('.product-detail .quantity-select option:selected').val() || 1;

    let form = {
        pid: $('.product-detail').data('pid'),
        quantity: quantity,
        personalizedObj: true,
        personalizationFullSVG: personalizationFullSVG,
        personalizationPositionKey: personalizationPositionKey,
        personalizationSmallSVG: personalizationSmallSVG,
        personalizationText: personalizationText,
        personalizationTextColor: personalizationTextColor,
        personalizationTextFont: personalizationTextFont,
        personalizationTextSVG: personalizationTextSVG,
        personalizationType: personalizationType,
        personalizationTextFontSize: '1 cm',
        personalizarionCost: $('.fnPersModal .fnPersModal-footer-priceWrp .price').text().trim(),
        isDate: false,
        isLove: false
    };
    if (isCartEdit && $('.js-confirmPersonalization').data('uuid') !== '' && $('.js-confirmPersonalization').data('new-size-pid')) {
        addToCartUrl = $('#updateCartUrl').val();
        if ($('.js-confirmPersonalization').data('uuid') !== '' && $('.js-confirmPersonalization').data('new-size-pid')) {
            let uuid = $('.js-confirmPersonalization').data('uuid');
            let newSizePid = $('.js-confirmPersonalization').data('new-size-pid');
            form.uuid = uuid;
            form.newSizePid = newSizePid;
        }
    }

    (isCartEdit) ? form.isCartEdit = true : null;

    if (quantity > 1) {
        if (isCartEdit) {
            form.uniqueIdentifiers = persOldOptions.relatedUniqueIdentifiers;
        } else {
            let uniqueIdentifiers = {};
            for (let i = 0; i < quantity; i++) {
                let random = Math.random();
                let id = 'uniqueIdentifier' + i;
                uniqueIdentifiers[id] = random;
            }
            uniqueIdentifiers = JSON.stringify(uniqueIdentifiers);
            form.uniqueIdentifiers = uniqueIdentifiers;
        }
    } else {
        form.uniqueIdentifier = (isCartEdit) ? persOldOptions.relatedUniqueIdentifier : Math.random();
    }
    if (addToCartUrl) {
        $.ajax({
            url: addToCartUrl,
            type: 'post',
            context: this,
            data: form,
            dataType: 'json',
            success: function (data) {
                if (data.error) {
                    $('.content-input-err').removeClass('hidden');
                } else {
                    if (isCartEdit) {
                        location.reload();
                    } else {
                        $('body').trigger('product:afterAddToCart', {
                            ...data,
                            form,
                            $productContainer: $('.product-detail'),
                            $analyticsContainer: $('.product-detail').siblings('.product.analytics').data()
                        });
                    }
                    closePersonalizationModal();
                    handlePostCartAdd(data);
                };
                $('.mobile-minicart .minicart-quantity').empty().append(data.quantityTotal);
            }
        });
    }
};

function initPersonalization (elem, inPdp) {
    let pid = $(elem).data('pid') || null;
    isCartEdit = $(elem).hasClass('js-personalization-edit');
    checkSizeAndScreen(pid) || isCartEdit || inPdp ? getCustomizeModal(elem) : null;
};

function preClosePersonalizationModal () {
    // create and open confirmation modal
    const htmlContent = document.getElementById('preClosePersonalizationModal').innerHTML;
    const modal = newModalFromString(htmlContent, false, ['personalization-close-modal']);

    $(modal.modalBox).on('click', '.cart-delete-confirmation-btn', (e) => {
        $('body').trigger('analytics:customizeProdActions', $(e.currentTarget).data('analytics-action'));
        closePersonalizationModal();
        modal.close();
        modal.destroy();
    });
    $(modal.modalBox).on('click', '.js-continue-personalization,.close', function (e) {
        $('body').trigger('analytics:customizeProdActions', $(e.currentTarget).data('analytics-action'));
        modal.close();
        modal.destroy();
    });

    modal.open();
};
function mobileLegalModal (e) {
    e.preventDefault();
    // create and open confirmation modal
    const htmlContent = document.getElementById('mobileLegalModal').innerHTML;
    const modal = newModalFromString(htmlContent, false, ['mobile-legal-modal']);

    $(modal.modalBox).on('click', '.cart-delete-confirmation-btn', () => {
        modal.close();
        modal.destroy();
    });

    modal.open();
};
$(document).on('click', '.js-personalization-edit', function (e) {
    e.preventDefault();
    initPersonalization(this);
});

$(document).on('click', '.fnPersModal-tabs .fnPersModal-tab', function (e) {
    e.preventDefault();
    let tabId = $(this).attr('data-tab');
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    $(this).closest('.fnPersModal-infoSection').find('.fnPersModal-tabContent.active').removeClass('active');
    $(this).closest('.fnPersModal-infoSection').find('.fnPersModal-tabContent[data-tab="' + tabId + '"').addClass('active');
});

$(document).off('click', '.fnPersModal .js-carousel-select-size .selectSizeRectangle ');
$(document).on('click', '.fnPersModal .js-carousel-select-size .selectSizeRectangle ', function (e) {
    e.preventDefault();
    let pid = $(e.currentTarget).find('input').data('sku');
    let url;
    if (!isCartEdit) {
        url = $('.js-createPersonalization').data('url') || null;
        let quantity = 1;
        url += '?pid=' + pid + '&quantity=' + quantity;
        if (url) {
            openPersonalizationModalStatus = true;
            globalHttpRequest(url).then(function (data) {
                reloadPersonalizationModal(data);
            });
        }
    } else {
        $('.js-confirmPersonalization').data('new-size-pid', pid);
    }
});

$(document).on('click', '.js-createPersonalizationOpenSize', function (e) {
    e.preventDefault();
    if (!isSizeSelected()) {
        if (Foundation.MediaQuery.atLeast('medium')) {
            // If no size is selected, open modal to choose one
            $('.product-availability').addClass('size-not-selected');
        } else {
            $('.js-accordion-size-wrapper').addClass('open-modal');
            $('body').addClass('is-modal-opened');
            $('.js-accordion-size-wrapper .add-to-cart.button').hide();
            $('.js-accordion-size-wrapper .js-createPersonalizationConfirmSize').removeClass('d-none');
        }
        return;
    }
    initPersonalization(this, true);
    $('body').trigger('analytics:openCustomizationModal');
});

$(document).on('click', '.js-createPersonalizationConfirmSize', function (e) {
    e.preventDefault();
    $('.js-accordion-wrapper').removeClass('open-modal');
    $('body').removeClass('is-modal-opened');
    $('.js-createPersonalizationOpenSize').trigger('click');
});

$(document).on('click', '.js-createSmartGiftConfirmSize', function (e) {
    e.preventDefault();
    $('.js-accordion-wrapper').removeClass('open-modal');
    $('body').removeClass('is-modal-opened');
    $('.smart-gift .js-smart-gift').trigger('click');
});

$(document).on('click', '.js-delete-embroidery', function (e) {
    e.preventDefault();
    $('.fnPersonalizationPageContainer .js-inputText').val('').trigger('change');
    $('.js-personalization-symbols .active').trigger('click');
});

export function callFromExternalModal (elem) {
    if (elem) {
        initPersonalization(elem);
    }
};
